export function parseNaturalInput(
    rawInput: string,
    options?: { maxDigits?: number },
): number | null {
    const trimmed = rawInput.trim();
    if (!/^\d+$/.test(trimmed)) return null;
    if (options?.maxDigits !== undefined && trimmed.length > options.maxDigits) return null;

    const parsed = Number(trimmed);
    return Number.isSafeInteger(parsed) && parsed >= 0 ? parsed : null;
}